import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { HIDE_POINT_TO_CASH_SECTION } from '../../utils/Config';
import { detectIsPadOrMobileByScreenWidth } from '../../utils/ScreenUtils';
import { navigateStack } from "utils/WeChatUtil";
import i18n from '../../utils/I18n';
import { CashDollarIcon, PointsIcon } from "../../component/base/SvgIcons";
import { enLocaleNumberFormatter } from "../../utils";
import { getMaxCashDollar } from '../profile/PointAndCashSection';
import UsePointToCashModal from '../profile/UsePointToCashModal';
import './PointToCashSection.scss';


const PointWithImage = ({
  title,
  image,
  content,
}) => (
  <div className='point-to-cash-section-single'>
    <span className='point-to-cash-section-title tag-menu-1'>
      {title}
    </span>
    <div className='point-to-cash-section-image-with-content'>
      {image}
      <span className='point-to-cash-section-content subheading'>
        {content}
      </span>
    </div>
  </div>
)

const PointToCashSection = ({
  language,
  isLogin,
  currentPoints,
  inBanner = false,
}) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const isMobile = detectIsPadOrMobileByScreenWidth();
  const maxCashDollar = getMaxCashDollar(currentPoints);

  const onClickSection = () => {
    if (HIDE_POINT_TO_CASH_SECTION) {
      return;
    };
    if (isMobile) {
      navigateStack({ pathname: "/use_cash_dollar", history })
      return;
    }
    if (!showModal) {
      setShowModal(true);
    }
  }

  if (!isLogin) {
    return null;
  };

  return (
    <>
      <div
        className={`point-to-cash-section-container ${inBanner ? "point-to-cash-section-container-in-banner" : ""}`}
        onClick={onClickSection}
      >
        <PointWithImage
          title={i18n.t("my_points")}
          image={<PointsIcon />}
          content={enLocaleNumberFormatter(currentPoints)}
        />
        <span className='point-to-cash-section-equal subheading'>=</span>
        <PointWithImage
          title={i18n.t("cash_dollar")}
          image={<CashDollarIcon />}
          content={enLocaleNumberFormatter(maxCashDollar)}
        />
      </div>
      <UsePointToCashModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  currentPoints: state.users.availablePoints,
});

export default connect(mapStateToProps)(PointToCashSection);
